import { Observable } from 'rxjs';

export class AuthenticatedUser {
    email: string;

    // Contains the Auth0 connection type: ie auth0, waad, google-oauth etc.
    // See claim being derived from context.connectionStrategy https://auth0.com/docs/customize/rules/context-object
    connectionProvider: string;

    // add more properties we might be interested here

    constructor(email = '', connectionProvider = '') {
        this.email = email;
        this.connectionProvider = connectionProvider;
    }
}

export interface AuthenticationProxy {
    getToken(): Observable<string>;
    getUser(): Observable<AuthenticatedUser>;
    goToApplication(): Promise<any>;
    goToLogin(): Promise<any>;
    isAuthenticated(): Observable<boolean>;
    logout(): void;
    redirectToTargetPath(): Promise<boolean>;
    fetchDeepLink(): Promise<string>;
    getErrorStream(): Observable<Error>;
    getErrors(): { hasErrors: boolean; errors: Error[] };
    clearErrors(): void;
}
